<style lang="scss">
  @import "@/assets/scss/vuexy/pages/CreateUser";
</style>

<template>
  <div class="create-user-component">
    <vx-card class="grid-view-item mb-base overflow-hidden">
      <h4>{{$t('Labels.AddUser')}}</h4>
      <form class="edit-form">
        <div class="item-grid-view vx-row match-height mt-4">
          <div class="w-full px-4">
            <div class="item-grid-view vx-row match-height">
              <div class="lg:w-1/2 sm:w-1/2 w-full px-4">
                <vs-input class="edit-info-input w-full" :label="$t('Labels.Name')" type="text" ref="first_name" v-model="first_name"/>
                <span class="text-danger text-sm error-message"  v-show="empty(first_name)">{{$t('Messages.Required')}}</span>
                <vs-input class="edit-info-input mt-4 w-full" :label="$t('Email')" type="email" ref="email" v-model="email"/>
                <span class="text-danger text-sm error-message"  v-show="empty(email)">{{$t('Messages.Required')}}</span>
                 <span class="text-danger text-sm error-message"  v-show="!emailValidate(email) && empty(email) == false">{{$t('Messages.EmailNoValid')}}</span>
                <vs-input class="edit-info-input mt-4 w-full" :label="$t('Password')" type="password" ref="user_password" v-model="password"/>
                <span class="text-danger text-sm error-message"  v-show="empty(password)">{{$t('Messages.Required')}}</span>
              </div>
              <div class="lg:w-1/2 sm:w-1/2 w-full px-4">
                <vs-input class="edit-info-input w-full" :label="$t('Labels.LastName')" type="text" ref="last_name" v-model="last_name"/>
                <span class="text-danger text-sm error-message"  v-show="empty(last_name)">{{$t('Messages.Required')}}</span>
                <div class="select-container mt-4">
                  <span class="select-label">{{$t('Labels.UserType')}}</span>
                  <v-select :options="user_types" v-model="user_type" class="user-type-select" :reduce="v => v.value"  :clearable="false"/>
                </div>
                <vs-input class="edit-info-input mt-4 w-full" :label="$t('Labels.ConfirmPassword')" type="password" ref="confirm_password" v-model="confirmPassword"/>
                <span class="text-danger text-sm error-message"  v-show="empty(confirmPassword)">{{$t('Messages.Required')}}</span>
                <span class="text-danger text-sm error-message"  v-show="password !== confirmPassword">{{$t('Messages.EqualPassword')}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full mt-5" v-if="user_type === 'MO'">
          <div class="w-full text-center mb-5">{{$tc('Devices',1)}}</div>
          <div class="flex">
            <div class="flex-1">
              <div class="w-full text-center font-bold mb-2">{{$t('Labels.NotAssigned')}}</div>
              <ul>
                <li :key="item.uuid" v-for="(item) in unassigned"  class="text-center p-1 cursor-pointer rounded-sm">
                  <vx-card class="h-6" :class="{ 'item-selected': item.selected,'border-cyan': item.selected,  'border-4': item.selected}" @click="item.selected = !item.selected">
                    <img alt="" class="h-6 inline-block" v-bind:src="getImgUrl(item.type)"/> {{ item.alias }}
                  </vx-card>
                </li>
              </ul>
            </div>
            <div class="flex-initial m-auto px-4">
              <vs-button class="mb-3" radius color="primary" type="filled" icon-pack="feather" icon="icon-arrow-right block" @click="assign()" ></vs-button>
              <vs-button radius color="primary" type="filled" icon-pack="feather" icon="icon-arrow-left block" @click="unassign()" ></vs-button>
            </div>
            <div class="flex-1">
              <div class="w-full text-center font-bold mb-2">{{$t('Labels.Assigned')}}</div>
                <ul>
                <li :key="index" v-for="(item, index) in assigned" class="text-center p-1 cursor-pointer rounded-sm">
                  <vx-card class="h-6" :class="{ 'item-selected': item.selected, 'border-cyan': item.selected,  'border-4': item.selected}" @click="item.selected = !item.selected">
                    <img alt="" class="h-6 inline-block" v-bind:src="getImgUrl(item.type)"/> {{ item.alias }}
                  </vx-card>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="submit-button-container mt-4 text-right">
          <vs-button @click="formSubmit" class="submit-button" :disabled="!valid" >
            {{$t('Labels.Save')}}
          </vs-button>
        </div>
      </form>
    </vx-card>
  </div>
</template>
<script>
import { request } from '@/request.js'
import vSelect from 'vue-select'
import { empty } from '@/helpers.js'

export default {
  components: {
    'v-select': vSelect
  },

  data () {
    return {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      confirmPassword: '',
      user_types: [
        { label: 'Selecciona una opción', value: '' },
        { label: 'Lectura', value: 'MO' },
        { label: 'Administrador', value: 'MA' }
      ],
      user_type: '',
      success: {
        successful: true
      },
      unassigned: [],
      assigned: [],
      empty
    }
  },

  methods: {
    async formSubmit (e) {
      e.preventDefault()

      const params = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        password: btoa(this.password),
        type: this.user_type
      }

      if (params.type === 'MO') {
        params.airflow = this.getAssignedByType('F')
        params.doors = this.getAssignedByType('P')
        params.energies = this.getAssignedByType('E')
        params.temphum = this.getAssignedByType('T')
      }

      const data = {
        url: 'modelo/users',
        method: 'POST',
        params
      }

      if (this.first_name.length > 0 && this.last_name.length > 0 && this.email.length > 0 && this.password.length > 0 && (this.password === this.confirmPassword)) {
        await request(data).then(() => {
          this.first_name = ''
          this.last_name = ''
          this.email = ''
          this.password = ''
          this.confirmPassword = ''
          this.type = { label: 'Lectura', value: 'MA' }
          window.location.href = '/users'
        }).catch(() => {
          this.password = ''
          this.confirmPassword = ''
        })
      }
    },
    async getDevices () {
      const params = {
        url: 'modelo/general',
        method: 'GET'
      }

      await request(params).then(response => {
        response.data.data.forEach(function (item) {
          item.selected = false
        })
        this.unassigned = response.data.data
      })
    },
    getImgUrl (name) {
      let img = ''
      switch (name) {
        case 'Temperatura y Humedad':
          img = 'envtemperature'
          break
        case 'Puertas':
          img = 'doors'
          break
        case 'Energia':
          img = 'energy'
          break
        case 'Flujo de Aire':
          img = 'airflow'
          break
        case 'Agro':
          img = 'agro'
          break
        default:
          break
      }
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${img}.svg`)
    },
    assign () {
      const toMove = this.unassigned.filter(element => element.selected === true)
      this.unassigned = this.unassigned.filter(element => element.selected === false)
      toMove.map(item => {
        item.selected = false
        this.assigned.push(item)
        return item
      })
    },
    unassign () {
      const toMove = this.assigned.filter(element => element.selected === true)
      this.assigned = this.assigned.filter(element => element.selected === false)
      toMove.map(item => {
        item.selected = false
        this.unassigned.push(item)
        return item
      })
    },
    getAssignedByType (type) {
      const devices = []
      this.assigned.map(item => {
        if (item.device === type) devices.push(item.uuid)
        return item
      })
      return devices.join(',')
    },
    emailValidate (email) {
      const reg = /^[^@]+@[^@]+\.[a-zA-Z]{2,}$/g
      console.log(email.match(reg) !== null)
      return email.match(reg) !== null
    }
  },
  computed: {
    valid () {
      return (!empty(this.first_name) && !empty(this.last_name) && !empty(this.email) && !empty(this.password) && !empty(this.confirmPassword) && (this.password === this.confirmPassword) && this.emailValidate(this.email))
    }
  },
  created () {
    this.getDevices()
  }
}
</script>
